<template>
  <div class="page-add-user">
    <p class="addText">添加后台账号</p>
    <el-form
      :label-position="labelPosition"
      label-width="120px"
      :model="formData"
      style="width: 400px"
      :rules="rules"
      ref="formData"
    >
      <el-form-item label="登录账号" prop="nickName">
        <el-input
          v-model="formData.nickName"
          placeholder="请输入账号"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="phone">
        <el-input
          v-model="formData.phone"
          placeholder="请输入手机号"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password">
        <el-input
          v-model="formData.password"
          placeholder="请输入密码"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select
          v-model="formData.type"
          placeholder="请选择角色"
          style="width: 100%"
          size="small"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="showCompany" label="账号所属公司">
        <el-select
          v-model="formData.companyId"
          placeholder="请选择账号所属公司"
          style="width: 100%"
          size="small"
          filterable
        >
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="el-form-item" style="width: 400px; text-align: center">
      <el-button type="primary" @click="submitForm('formData')" size="small"
        >添加</el-button
      >
    </div>
  </div>
</template>

<script>
import { Form as ElForm } from "element-ui";
export default {
  name: "AddUser",
  components: {},
  data() {
    let validateMobilePhone = (rule, value, callback) => {
      if (!value.trim()) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码长度不小于6位"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      rules: {
        nickName: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, validator: validateMobilePhone, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "长度在 6 到 18 个字符",
            trigger: "blur",
          },
        ],
        role_ids: [
          // { required: true, message: '请选择角色', trigger: 'change' }
        ],
      },
      labelPosition: "right",
      role: "",
      isDel: false,
      seletIndex: 0,
      fileList: [],
      options: [
        {
          value: 3,
          label: "运营人员",
        },
      ],
      formData: {
        nickName: "",
        password: "",
        phone: "",
        realName: "",
        roleIds: [],
        type: 3,
      },
      companyList: [],
      showCompany: true,
    };
  },
  mounted() {
    this.getCompanyList();
    if (window.userInfo.companyId) {
      this.showCompany = false;
      this.formData.companyId = window.userInfo.companyId;
      this.options = [
        {
          value: 4,
          label: "运营用户",
        },
      ];
      this.formData.type = 4;
    } else {
      this.showCompany = true;
      this.options = [
        {
          value: 3,
          label: "运营人员",
        },
      ];
      this.formData.type = 3;
    }
    console.log(window.userInfo.companyId);
  },
  methods: {
    async getCompanyList() {
      let data = await this.$get("/company/all");
      this.companyList = data;
    },
    handleDelete(index, row) {
      this.seletIndex = index;
      this.isDel = true;
    },
    // 确定删除
    primaryClick() {
      this.$message({
        type: "success",
        message: "删除成功",
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file, fileList) {
      //return this.$confirm(`确定移除 ${ file.name }？`);
    },
    submitForm(formName) {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            await this.$post("/user/addOrEdit", { ...this.formData });
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.$refs.formData.resetFields();
            if (window.userInfo.companyId) {
              this.formData.type = 4;
              this.formData.companyId = window.userInfo.companyId;
            } else {
              this.formData.type = 3;
              this.formData.companyId = "";
            }
            setTimeout(() => {
              this.loading = false;
            }, 0.5 * 1000);
          } catch (error) {
            this.loading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-add-user {
  height: 100%;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .table-box {
    font-size: 14px;
  }
  .addText {
    width: 500px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .pages {
    background: #fff;
    margin-top: 10px;
    padding: 10px 10px;
    text-align: right;
    height: 55px;
    box-sizing: border-box;
  }
  .search-box {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px 10px;
    border-radius: 4px;
    height: 55px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 20px;
      width: 300px;
      margin-right: 10px;
    }
  }
}
</style>
